import React from 'react';
import { View } from 'react-native';

import { ICarouselInstance, TCarouselProps } from '@components/Carousel';

// TODO: Use react-native-reanimated-carousel once 4.x.x
// is released, which appears to fix the web issues
const Carousel = React.forwardRef<ICarouselInstance, TCarouselProps<any>>(
  function Carousel(props, ref) {
    const { data, renderItem, width, height } = props;
    const [currentIndex, setCurrentIndex] = React.useState(0);

    React.useImperativeHandle(ref, () => {
      return {
        next() {
          setCurrentIndex((curr) => Math.min(curr + 1, data.length - 1));
        },
        prev() {
          setCurrentIndex((curr) => Math.max(curr - 1, 0));
        },
        getCurrentIndex() {
          return currentIndex;
        },
        scrollTo(options) {
          if (typeof options?.index === 'number') {
            setCurrentIndex(options.index);
          }
        },
      };
    }, [currentIndex, data.length]);

    return (
      <View
        style={{
          width,
          height,
        }}>
        {renderItem({ item: data[currentIndex], index: currentIndex, animationValue: null })}
      </View>
    );
  }
);

export default Carousel;
